import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import configBase from '../../../configBase';
import axios from 'axios';



class Sair extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      
    };

  }


  componentDidMount() {
    let access_token = window.localStorage.getItem('planos_t');

    axios.post(configBase.api + 'Accounts/logout?access_token=' + access_token)
    .then(() => {
      this.removeLocalStorage();
    })
    .catch(function () {
      this.removeLocalStorage();
    }.bind(this));
  }

  removeLocalStorage() {
    window.localStorage.removeItem('planos_t');
    window.localStorage.removeItem('planos_u');
    window.localStorage.removeItem('planos_y');
    window.localStorage.removeItem('planos_n');
    window.localStorage.removeItem('planos_i');

    window.location.href = `${process.env.PUBLIC_URL}/entrar`;
  }

  render() {

    return (<span>&nbsp;</span>);

  }

}

Sair.propTypes = {
  history: PropTypes.object
};

export default withRouter(Sair);